import { Stack } from '@mui/material';
import { UploadFileArea } from '../UploadFileArea';
import { FileNote } from '../../../Common/FileNote';
import { useContext } from 'react';
import { AlternativeMedicineContext } from 'Context/AlternativeMedicine';
import { GettingStartNote } from 'Modules/Reimbursements/Common/GettingStartNote';
import { BackButton } from '../BackButton';

export const GettingStartedSection = () => {
  const { isFileError } = useContext(AlternativeMedicineContext);

  return (
    <Stack sx={{ gap: '32px', maxWidth: '800px', m: '0 auto' }}>
      <GettingStartNote isFileError={isFileError} />
      <UploadFileArea />
      <FileNote />
      <BackButton />
    </Stack>
  );
};
